module.exports = __webpack_public_path__ + "static/media/PointIcon.e54c550b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/google-map/PointIcon.svg
// module id = 711
// module chunks = 0